import { render } from "./SideNavbar.vue?vue&type=template&id=7c31e2dc"
import script from "./SideNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavbar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/SideNavbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c31e2dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c31e2dc', __exports__)) {
    api.reload('7c31e2dc', __exports__)
  }
  
  module.hot.accept("./SideNavbar.vue?vue&type=template&id=7c31e2dc", () => {
    api.rerender('7c31e2dc', render)
  })

}


export default __exports__